import { auth } from '../firebase/config';

/**
 * fetch mot egna Netlify Functions med inloggad användares Firebase ID-token
 * i `Authorization: Bearer …`. Funktionerna kontrollerar token med
 * netlify/functions/_lib/auth.js (requireMember).
 *
 * Samma signatur som fetch. Utan inloggad användare skickas anropet utan
 * token och funktionen svarar 401.
 */
export async function authFetch(url, options = {}) {
  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : null;
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}
